import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    CardContainer,
    CardImage,
    CardBody,
    CardFooter,
    BookingLinks,
    BookingLink,
    Subtitle,
    Title,
    SubtitleSpan,
    ButtonStyled,
    InfoRow,
    InfoItem,
} from './Card.styles';


const getPlatformColor = (platform = "") => {
    const p = platform.toLowerCase();
    if (p.includes("airbnb")) return "#FF5A5F";
    if (p.includes("booking")) return "#003580";
    if (p.includes("expedia")) return "#FFC72C";
    if (p.includes("vrbo")) return "#1B6FE4";
    if (p.includes("agoda")) return "#E61E4D";
    if (p.includes("marriott")) return "#8B0000";
    return "#61CBC9"; // KozyGuru / 其他
};

const Card = ({
    name,
    city,
    street,
    status,
    channels = [],
    bedrooms,
    bathrooms,
    beds,
    guests,
    kozyGuruName,
    image,
    buttonLabel,
    buttonLink,
    listingId,
    isServicePms = true,
}) => {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        if (!isServicePms) return;
        if (buttonLink?.startsWith('/')) {
            navigate(buttonLink);
        } else if (buttonLink) {
            window.open(buttonLink, '_blank');
        }
    };

    return (
        <CardContainer onClick={handleButtonClick}>
            {/* 圖片 */}
            {image ? <CardImage src={image} alt={name} /> : <p>No Image Available</p>}

            <CardBody>
                <Title>{name}</Title>
                {kozyGuruName && <Subtitle>{kozyGuruName}</Subtitle>}
                <Subtitle>{city}, {street}</Subtitle>
                {/*<InfoRow>                                            
                    <InfoItem>🛏 {bedrooms} Bed</InfoItem>
                    <InfoItem>🚿 {bathrooms} Bath</InfoItem>
                    <InfoItem>🛌 {beds} Beds</InfoItem>
                    <InfoItem>👤 {guests} Guests</InfoItem>
                </InfoRow>*/}
                <CardFooter>
                    {!isServicePms ? (
                        // Service Off：不顯示 channels 和按鈕
                        <div style={{
                            padding: "6px 14px",
                            borderRadius: "999px",
                            backgroundColor: "#e0e0e0",
                            color: "#888",
                            fontSize: "12px",
                            fontWeight: 600,
                            display: "inline-block",
                        }}>
                            Service Off
                        </div>
                    ) : (
                        <>
                            <BookingLinks>
                                {channels
                                    ?.filter(ch => ch.online)
                                    ?.map((ch, index) => (
                                        <BookingLink
                                            key={index}
                                            href={ch.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => e.stopPropagation()}
                                            platformcolor={getPlatformColor(ch.platform)}
                                        >
                                            {ch.platform}
                                        </BookingLink>
                                    ))}
                            </BookingLinks>

                            {buttonLabel && buttonLink && (
                                <ButtonStyled onClick={handleButtonClick}>
                                    {buttonLabel}
                                </ButtonStyled>
                            )}
                        </>
                    )}
                </CardFooter>
            </CardBody>
        </CardContainer>
    );
};

export default Card;
